import { StripePaymentConfigTypes } from "../components/payments/components/StripePayment";
import { apiClient } from "../services/axiosInstance";
import { ServerSingleResponse } from "../types";
import { ReaderNavigationContext } from "../screens/reader/types";
import { buildContextQueryParams } from "../utils/buildContextQueryParams";

export function postToggleFollow(
  artistId: number,
  unfollow: boolean = false,
  context?: ReaderNavigationContext,
) {
  return apiClient.post<ServerSingleResponse<boolean>>(
    `/v1/artists/${artistId}/toggle-follow`,
    { meta: [], payload: { intent: unfollow ? "unfollow" : "follow" } },
    { params: context ? buildContextQueryParams(context) : undefined },
  );
}

type DonationPayload = StripePaymentConfigTypes & {
  netAmount: number;
  isRecurring: boolean;
  note?: string;
};
export function postArtistDonation(artistId: number, payload: DonationPayload) {
  return apiClient.post<ServerSingleResponse<unknown>>(
    `/v1/artists/${artistId}/donate`,
    { meta: [], payload },
  );
}
